module.exports = __webpack_public_path__ + "img/t4-7.6ed73662.svg";